<template>
    <div class="element-cardtype-box">
        <div class="element-box map-element-box" v-if="project">
            <div class="element-body">
                <div class="element-image"
                     :style="{ backgroundImage: 'url(' + project.profile_image_url + ')' }"
                >
                    <div class="pb">
                        <p class="tag tag-photo">
                            <i class="fad fa-image"></i>
                            <span> {{project.media_count}} </span>
                        </p>
                        <p class="tag tag-video">
                            <i class="fad fa-play-circle"></i>
                            <span> {{project.videos.length}} </span>
                        </p>
                    </div>
                </div>
                <div class="element-header">
                    <div class="element-info">
                        <a :href="`${project.url}${transformArrayToQueryParams(urlParams)}`" class="general-link element-name">
                            {{project.name}}
                        </a>
                        <div class="element-location">
                            <i class="fad fa-map-marker-alt"></i>
                            <p>
                                {{getProjectLocation()}}
                            </p>
                        </div>
                        <div class="element-footer">
                            <div class="element-size">
                                <div class="element-footer-box">
                                    <i class="fad fa-ruler-triangle"></i>
                                    <span> Suprafata intre: </span>
                                </div>
                                <p v-if="project.min_surface != project.max_surface">
                                    {{project.min_surface}} - {{project.max_surface}} (m²)
                                </p>
                                <p v-else>
                                    {{project.min_surface}} (m²)
                                </p>
                            </div>
                            <div class="element-price">
                                <div class="element-footer-box">
                                    <i class="fad fa-sack-dollar"></i>
                                    <span> Pret intre:  </span>
                                </div>
                                <p>
                                    <span class="regular-price" v-if="project.min_price != project.max_price">
                                        {{formatPrice(project.min_price, false)}} - {{formatPrice(project.max_price)}}
                                    </span>
                                    <span class="regular-price" v-else>
                                        {{formatPrice(project.min_price)}}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <p class="element-description">
                    {{project.short_desc}}
                </p> -->
                <div class="element-particularities">
                    <div class="ep ep1">
                        <i class="fad fa-building"></i>
                        <span v-if="!project.hasAccessToProjectItems"
                              class="item-action-btn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Pentru informatii despre numarul de apartamente disponibil sunati la numarul de contact din proiect">
                            <i class="fad fa-info-circle"></i> Apartamente
                        </span>
                        <span v-else-if="project.apartments_count === 0"
                              class="item-action-btn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Dezvoltatorul nu a afisat disponibilitatile">
                            <i class="fad fa-info-circle"></i> Apartamente
                        </span>
                        <span v-else> {{project.apartments_count}} Apartamente  </span>
                    </div>
                    <div class="ep ep2">
                        <i class="fad fa-home-lg-alt"></i>
                        <span v-if="!project.hasAccessToProjectItems"
                              class="item-action-btn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Pentru informatii despre numarul de case disponibil sunati la numarul de contact din proiect">
                            <i class="fad fa-info-circle"></i> Case
                        </span>
                        <span v-else-if="project.houses_count === 0"
                              class="item-action-btn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Dezvoltatorul nu a afisat disponibilitatile">
                            <i class="fad fa-info-circle"></i> Case
                        </span>
                        <span v-else> {{project.houses_count}} Case  </span>
                    </div>
                    <div class="ep ep3">
                        <i class="fad fa-object-group"></i>
                        <span v-if="!project.hasAccessToProjectItems"
                              class="item-action-btn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Pentru informatii despre numarul de spaţii disponibil sunati la numarul de contact din proiect">
                            <i class="fad fa-info-circle"></i> Spaţii
                        </span>
                        <span v-else-if="project.commercials_count === 0"
                              class="item-action-btn"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Dezvoltatorul nu a afisat disponibilitatile">
                            <i class="fad fa-info-circle"></i> Spaţii
                        </span>
                        <span v-else> {{project.commercials_count}} Spaţii  </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "ProjectItemMaps",
    props: ['urlParams'],
    data() {
      return {
        project: null
      }
    },
    methods: {
      getProjectLocation() {
        let location = this.project.county.name + ', ' + this.project.city.name;
        if (this.project.zone) {
          location += ', ' + this.project.zone.name;
        }
        if (this.project.subzone) {
          location += ', ' + this.project.subzone.name;
        }
        return location;
      }
    }
  }
</script>

<style scoped>

</style>
